import { ArrowIcon } from "../../../../../assets/img/svg/ArrowIcon";

import { ArrowWrapper } from "../arrowStyles/ArrowStyles.styled";

const ArrowLeft = () => {
  return (
    <ArrowWrapper left>
      <ArrowIcon />
    </ArrowWrapper>
  );
};

export default ArrowLeft;
